var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#E8E8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_1071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4758 16.6623H16.6633V22.4748C16.6633 23.1142 16.1402 23.6373 15.5008 23.6373C14.8614 23.6373 14.3383 23.1142 14.3383 22.4748V16.6623H8.52578C7.88641 16.6623 7.36328 16.1392 7.36328 15.4998C7.36328 14.8604 7.88641 14.3373 8.52578 14.3373H14.3383V8.5248C14.3383 7.88543 14.8614 7.3623 15.5008 7.3623C16.1402 7.3623 16.6633 7.88543 16.6633 8.5248V14.3373H22.4758C23.1152 14.3373 23.6383 14.8604 23.6383 15.4998C23.6383 16.1392 23.1152 16.6623 22.4758 16.6623Z",
    fill: "#767676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_1071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9,
    height: 27.9,
    fill: "white",
    transform: "translate(1.55078 1.5498)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/AddFile.9379611f2549c9d374099eb3050b502d.svg";
export { ForwardRef as ReactComponent };